function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 15.4769V18.234H7.87111L16.339 10.1024L13.4679 7.34536L5 15.4769ZM7.23564 16.7635H6.53126V16.0871L13.4679 9.42604L14.1722 10.1024L7.23564 16.7635ZM18.5593 6.93363L16.7677 5.21321C16.6146 5.06617 16.4232 5 16.2241 5C16.0251 5 15.8336 5.07352 15.6882 5.21321L14.2871 6.55867L17.1582 9.31575L18.5593 7.9703C18.8579 7.68356 18.8579 7.22037 18.5593 6.93363Z",
  fill: "#C1C1C1"
});

var SvgDisabledEdit = function SvgDisabledEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDisabledEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/disabled-edit.05933a2c.svg";
export { ForwardRef as ReactComponent };